export default __webpack_public_path__ + "a82aac91b1cf17c0915a6677c487b2e0.svg";